var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduce"},[_c('div',{staticClass:"bigImg"}),_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require("../../static/introduce/ldj.jpg"),"alt":""}}),_c('img',{attrs:{"src":require("../../static/introduce/ldy.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }